import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { ProductDetailsContext } from '../context';
import { messages } from '../messages';

import style from '../style.module.less';

export const ProductDetailsWeightPresetGroupDisplay = () => {
  const { currentProductProfile, parentProduct } = useContext(ProductDetailsContext);

  const inheritedValues = {
    weight: currentProductProfile.weight || parentProduct.weight,
    weightMessage: currentProductProfile.weight ? messages.presetGroupInfo : messages.parentInfo,
  };

  return (
    <div className={style['profile-info']}>
      {inheritedValues.weight && (
        <div>
          <FormattedMessage {...inheritedValues.weightMessage} />
          &nbsp;{inheritedValues.weight}
        </div>
      )}
    </div>
  );
};
